module.exports = __webpack_public_path__ + "static/media/touch-icon-144x144.ef5e7365.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/images/touch/touch-icon-144x144.png
// module id = 275
// module chunks = 61